import React, { Fragment, useState, useEffect, useRef } from "react";
// import uuid from "uuid";
import { v4 as uuid } from "uuid";
import clsx from "clsx";
import { isEmpty } from "../../utils/utils";
import Skeleton from "./Skeleton";
import { iconCheck, iconArrow } from "./icons";

/**
 * Select React Component
 * Examples:
   const [selected, setSelected] = useState(null)

   <Select
     label="Texto"
     selected={selected}
     onClick={row => setSelected(row)}
     items={[ {value: 1, text: 'texto1' }, {value: 2, text: 'texto2' } ]}
     className='' // Opcional
   />
 */
const Select = ({
  id = null,
  items, // [{ value, text, render(optional) }]
  label,
  selected,
  className,
  disabled,
  hiddenSelected,
  loading = false,
  filterable = false,
  notResultText = "No se encontraron resultados",
  hasError = null, // ENVIAR UN TEXTO O COMPONENTE
  hasSpan = null, // ENVIAR UN TEXTO O COMPONENTE
  onChange,
  sufixHolder = null,
  defaultItemsView = 3,
  defaultViewMoreItems = 1.5,
  classNameList
}) => {
  const [opened, setOpened] = useState(false);
  const [enabled, setDisabled] = useState(disabled || false);
  const [inputFilled, setInputFilled] = useState(null);
  const [placeholder, setPlaceholder] = useState("");
  const inputEl = useRef(null);
  const tempItems = filterable
    ? (items || []).filter((row) => {
        if (inputFilled && inputFilled.length) {
          return (
            row.text.toUpperCase().slice(0, inputFilled.length) ===
            inputFilled.toUpperCase()
          );
        }
        return row;
      })
    : items || [];
  const heightRow = 106;
  let height =
    (tempItems || []).length > defaultItemsView - (!hiddenSelected ? 0 : 1)
      ? !hiddenSelected
        ? heightRow * (defaultItemsView + defaultViewMoreItems)
        : heightRow * (tempItems || []).length + 1
      : ((tempItems || []).length + 1 - (!hiddenSelected ? 0 : 1)) * heightRow;

  height =
    filterable && tempItems.length === 0
      ? heightRow * (defaultItemsView - 1)
      : height;

  const refDropdown = useRef(null);

  useEffect(() => {
    setDisabled(!enabled);
  }, [disabled]);

  useEffect(() => {
    if (
      selected &&
      selected.text &&
      (selected.text || "").toString().trim().length > 0
    ) {
      setPlaceholder((selected.text || "").toString().trim());
    }
    if (selected === null && filterable) {
      setPlaceholder("");
    }
  }, [selected]);

  const onClick = (row) => {
    if (!disabled) {
      onChange(row);
      outsideEvt();
    }
  };

  const onOpen = (row) => {
    if (!disabled) {
      setOpened(row);
    }
  };

  const onToggle = () => {
    if (!opened) {
      onOpen(true);
      if (filterable) inputEl.current.focus();
      if (filterable && selected) {
        setInputFilled("");
        setPlaceholder(selected.text);
      }
    } else {
      setOpened(false);
      if (filterable && selected) {
        setInputFilled("");
        inputEl.current.blur();
      }
    }
  };

  const handleUserKeyPress = (event) => {
    if (event.keyCode === 27) {
      outsideEvt();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleUserKeyPress);

    return () => window.removeEventListener("keydown", handleUserKeyPress);
  }, []);

  const mouseDownEvt = (event) => {
    if (
      refDropdown &&
      refDropdown.current.contains(event.target) &&
      refDropdown.current === event.target.closest(".rd--select")
    ) {
      return;
    }
    outsideEvt();
  };

  useEffect(() => {
    document.addEventListener("mousedown", mouseDownEvt);
    return () => document.removeEventListener("mousedown", mouseDownEvt);
  }, []);

  const outsideEvt = () => {
    setInputFilled("");
    setOpened(false);
  };

  const onChangeInput = (e) => {
    const { value } = e.target;
    onOpen(true);

    if (value) {
      setInputFilled(value);
    } else {
      setInputFilled(null);
    }
  };

  const renderContentInput = () => (
    <div className="rd--select-content">
      {label && label.trim().length > 0 ? <label>{label}</label> : null}
      <input
        placeholder={placeholder}
        value={inputFilled}
        onChange={onChangeInput}
        ref={inputEl}
      />
    </div>
  );

  const renderContentSelect = () => (
    <div className="rd--select-content">
      {label && (label || "").toString().trim().length > 0 ? (
        <label>{label}</label>
      ) : null}
      {selected &&
      selected.text &&
      (selected.text || "").toString().trim().length > 0 ? (
        <span>{selected.text}</span>
      ) : null}
    </div>
  );

  const renderLoading = () => (
    <div className="rd--select-list">
      <div className="rd--select-list-item">
        <Skeleton width="240px" height="20px"></Skeleton>
      </div>
      <div className="rd--select-list-item">
        <Skeleton width="176px" height="20px"></Skeleton>
      </div>
      <div className="rd--select-list-item">
        <Skeleton width="240px" height="20px"></Skeleton>
      </div>
      <div className="rd--select-list-item">
        <Skeleton width="176px" height="20px"></Skeleton>
      </div>
    </div>
  );

  const renderItems = () => (
    <div
      className={`rd--select-list ${classNameList} ${tempItems.length > 3 ? "has-scroll" : ""} ${
        filterable && tempItems.length === 0
          ? "rd--select-list-item--not-results"
          : ""
      }`}
      style={{ maxHeight: height - heightRow }}
    >  
      <div
        key={uuid()}
        className={'rd--select-list-item'}
        style={{color:'#a9b1d1'}}
        onClick={() => onClick({value:''})}
      >
        {'Seleccione'}        
      </div>
      {tempItems.map((row, index) => (
        <div
          key={uuid()}
          className={`rd--select-list-item ${
            selected && row.value === selected.value ? "selected" : ""
          }
            `.trim()}
          onClick={() => onClick(row)}
        >
          {row.text || row.render}
          {selected && row.value === selected.value && (
            <div className="rd--select-check">{iconCheck}</div>
          )}
        </div>
      ))}
      {filterable && tempItems.length === 0 && (
        <div key={uuid()} className="rd--select-list-item not-results">
          {notResultText}
        </div>
      )}
    </div>
  );

  const getHeightShadow = () => {
    if (loading) {
      return "280px";
    }
    if (opened) {
      return filterable && tempItems.length === 0 ? "168px" : height;
    }
    return "initial";
  };

  return (
    <>
      <div
        id={id}
        ref={refDropdown}
        className={clsx("rd--select", className, {
          ["has-span"]: hasSpan,
          ["has-error"]: hasError,
          ["opened"]: opened,
          ["hidden-selected"]: hiddenSelected,
          ["hasnt-label"]: !label,
          ["filterable"]: filterable,
          ["disabled"]: disabled,
          ["has-value"]:
            !isEmpty(selected) || (filterable && !isEmpty(inputFilled)),
        })}
      >
        <div className="rd--select-input" onClick={onToggle}>
          {!filterable ? renderContentSelect() : renderContentInput()}
          {sufixHolder && (
            <span className="rd--select--sufix">{sufixHolder}</span>
          )}
          <div className="rd--select-arrow">{iconArrow}</div>
        </div>
        {loading ? renderLoading() : renderItems()}
        <div
          className="rd--select-shadow"
          style={{ height: getHeightShadow() }}
        />
      </div>
      {/*hasError && (
        <span className="rd--select-error" htmlFor={id}>
          {hasError}
        </span>
      )*/}
      {hasSpan && (
        <span className="rd--select-span" htmlFor={id}>
          {hasSpan}
        </span>
      )}
    </>
  );
};

export default Select;
